/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import {
    LIST_SCREEN_GHOST_HIGHLIGHT,
    LIST_SCREEN_LIMIT,
    LIST_SCREEN_UPDATE_CARET_VISIBLE,
    SET_LIST_ENTRY_PAGE,
    SET_VIEW_SCREEN_LIST_ENTRY_POSITION,
} from './listviewscreen.types';

export const setListEntryActions = (position: number): TivoPayloadAction<{ position: number }> => ({
    type: SET_VIEW_SCREEN_LIST_ENTRY_POSITION,
    payload: { position },
});

export const setListEntryPageActions = (page: number): TivoPayloadAction<{ page: number }> => ({
    type: SET_LIST_ENTRY_PAGE,
    payload: { page },
});

export const updateListScreenCaretVisibilityAction = (isCaretVisible: boolean) => ({
    type: LIST_SCREEN_UPDATE_CARET_VISIBLE,
    payload: { isCaretVisible },
});

export const setListViewScreenGhostModeAction = (ghostMode: boolean) => ({
    type: LIST_SCREEN_GHOST_HIGHLIGHT,
    payload: { ghostMode },
});

export const setListLimitActions = (limit: number): TivoPayloadAction<{ limit: number }> => ({
    type: LIST_SCREEN_LIMIT,
    payload: { limit },
});
